import cn from 'classnames';

import { IStatus } from 'source/NFR.types';
import { Status_Theme } from 'source/NFR.types';

const themes: Record<number, string> = {
  [Status_Theme.None]: '',
  [Status_Theme.IsActive]: 'status--is-active',
  [Status_Theme.IsCompleted]: 'status--is-completed',
  [Status_Theme.ResultIsPublished]: 'status--result-is-published',
  [Status_Theme.IsCanceled]: 'status--is-canceled',
  [Status_Theme.IsPlanned]: 'status--is-planned'
};

export interface IStatusProps extends IStatus {
  centered?: boolean;
}

const Status: React.FC<IStatusProps> = ({ theme, centered, text }) => {
  if (!text) return null;
  return (
    <div
      className={cn('status', theme ? themes[theme] : '', {
        'status--align-center': centered
      })}
    >
      {text}
    </div>
  );
};

Status.displayName = 'Status';

export default Status;
